import React from 'react';
import Icon from 'src/components/Common/Icon';
import Link from 'src/components/Common/Link';
import classNames from 'classnames';

export const DataLanguageTypeOptions = [
  'c++',
  'Elixir',
  'JavaScript',
  'Go',
  'Python',
  'Typescript',
  'Vim script',
  'none',
];
type DataLanguageType = (typeof DataLanguageTypeOptions)[number];

// TODO: Maybe split data prop into multiple props?
interface GithubRepoProps {
  className?: string;
  data: {
    /** Description of the GithubRepo. */
    description: string;
    /** The number of forks created from the GithubRepo. */
    forksCount: number;
    /** The name of the GithubRepo. */
    fullName: string;
    /** Link to the GithubRepo. */
    htmlUrl: string;
    /** Main Language of the GithubRepo. */
    language: DataLanguageType;
    /** Amount of stars the GithubRepo has. */
    stargazersCount: number;
  };
}

/** Renders a clickable Github Repo in a Box with name, description, language, and star and fork count. */
const GithubRepo = ({
  className,
  data: {
    description,
    forksCount,
    fullName,
    htmlUrl,
    language,
    stargazersCount,
  },
}: GithubRepoProps) => {
  let color;
  switch (language) {
    case 'C++':
      color = '#f34b7d';
      break;
    case 'Elixir':
      color = '#6e4a7e';
      break;
    case 'JavaScript':
      color = '#f1e05a';
      break;
    case 'Go':
      color = '##00ADD8';
      break;
    case 'Python':
      color = '#3572A5';
      break;
    case 'TypeScript':
      color = '#2b7489';
      break;
    case 'Vim script':
      color = '#199f4b';
      break;
    default:
      color = '#586069';
      break;
  }
  return (
    <Link
      className={classNames(className, 'ce-git-item')}
      to={htmlUrl}
      targetBlank
      title={description}
    >
      <div>
        <div className="header">
          <div className="title">{fullName}</div>
          <Icon name="fa-github" faStyle="brands" className="text-lg" />
        </div>
        <p>{description}</p>
        <div className="footer">
          {language && (
            <div>
              <span style={{ color }}>
                <Icon name="fa-circle" />
              </span>{' '}
              {language}
            </div>
          )}
          <div>
            <Icon name="fa-star" /> {stargazersCount}
          </div>
          <div>
            <Icon name="fa-code-fork" /> {forksCount}
          </div>
        </div>
      </div>
    </Link>
  );
};

GithubRepo.defaultProps = {
  className: null,
};

export default GithubRepo;
